import { useEffect, useState } from 'react';
import { smsService } from '@services/api/smsService';
import { getSMSCategoryLabel, calculateSMSSegments, estimateSMSCost } from '@/types/sms';
import type { SMSTemplate } from '@/types/sms';

export const SMSTemplates = () => {
  const [templates, setTemplates] = useState<SMSTemplate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    const result = await smsService.getTemplates();
    if (result.success && result.data) {
      setTemplates(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading templates...</div>;

  return (
    <div>
      <h2>SMS Templates</h2>
      <p className="text-secondary">Manage SMS message templates with variable support</p>
      
      <div className="table-container" style={{ marginTop: 'var(--spacing-xl)' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
              <th>Language</th>
              <th>Message Preview</th>
              <th>Characters</th>
              <th>Est. Cost</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template) => {
              const segments = calculateSMSSegments(template.message_template);
              const cost = estimateSMSCost(segments);
              
              return (
                <tr key={template.id}>
                  <td className="font-weight-600">{template.name}</td>
                  <td>{getSMSCategoryLabel(template.category)}</td>
                  <td className="text-uppercase">{template.language}</td>
                  <td className="text-small">{template.message_template.slice(0, 50)}...</td>
                  <td className="text-small">{template.character_count}</td>
                  <td className="text-small">AED {cost.toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

